import React from 'react';
import { OverlayToaster, ToastProps } from '@blueprintjs/core';
import { createRoot } from 'react-dom/client';

// TODO: check on future versions if option bellow is working
// export const AppToaster = OverlayToaster.createAsync({
//     className: "recipe-toaster",
//     position: Position.TOP,
// });

class AppToaster {
  toaster: React.RefObject<OverlayToaster>;

  constructor() {
    this.toaster = React.createRef<OverlayToaster>();

    const container = document.getElementById('toaster');
    if (!!container) {
      const toaster = createRoot(container);
      toaster.render(<OverlayToaster ref={this.toaster} />);
    }
  }

  public show(options: ToastProps) {
    this.toaster.current?.show({ ...options });
  }
}

const Toaster = new AppToaster();
export default Toaster;
